// src/pages/PrepaidPackagesPage.js
//
// Ön ödemeli (ömürlük) eSIM paketleri: lifetime ailesinin tüm bundle'ları.
import React from 'react';
import ContinentPackages from '../components/catalog/ContinentPackages';

const PrepaidPackagesPage = () => (
    <ContinentPackages
        family="lifetime"
        title="Ön Ödemeli eSIM Paketleri"
        subtitle="Kıta bazlı ömür boyu paketlerin fiyatlarını, mağaza durumlarını ve yayınını yönetin."
    />
);

export default PrepaidPackagesPage;
